import React, { useContext } from 'react';
import { Switch } from 'antd';

import SoftwareContext from '@totem/components/software/software_report/softwareContext';

const SwitchMonitored = () => {
  const { monitoredOnly, setMonitoredOnly } = useContext(SoftwareContext);

  return (
    <>
      Monitored:
      <Switch
        style={{ marginRight: '16px', marginLeft: '8px' }}
        onChange={setMonitoredOnly}
        value={monitoredOnly}
      />
    </>
  );
};

export default SwitchMonitored;
